import { render } from "./Survey.vue.ts?vue&type=template&id=d13e62ef&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Survey.vue?vue&type=template&id=d13e62ef&scoped=true&ts=true"
import script from "./Survey.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Survey.vue?vue&type=script&setup=true&lang=ts"
export * from "./Survey.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Survey.vue?vue&type=script&setup=true&lang=ts"

import "./Survey.vue.scss?vue&type=style&index=0&id=d13e62ef&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Survey.vue?vue&type=style&index=0&id=d13e62ef&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13e62ef"],['__file',"src/apps/merchant3/components/self-onboarding/survey/Survey.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d13e62ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d13e62ef', __exports__)) {
    api.reload('d13e62ef', __exports__)
  }
  
  module.hot.accept("./Survey.vue.ts?vue&type=template&id=d13e62ef&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Survey.vue?vue&type=template&id=d13e62ef&scoped=true&ts=true", () => {
    api.rerender('d13e62ef', render)
  })

}


export default __exports__